import React from 'react'
import { pdf, PDFViewer } from '@react-pdf/renderer'
import { useDispatch, useSelector } from 'react-redux'
import ModalDetailComponent from '../../components/ModalDetailComponent'
import { openPDF } from '../../redux/slice/leanSlice'
import PDFLean from './PDFLean'

const PopupPDFLean = (props) => {
    const dispatch = useDispatch()
    
    return (
      <ModalDetailComponent
        title="PDF Jumlah Orang Bersandar"
        show={props.isOpenPDF}
        close={() => dispatch(openPDF({ open: false }))}
        idForm="prev-form"
        size="lg"
      >
        <PDFViewer height={400} width={'100%'}>
          <PDFLean dataLean={props.dataLean} filter={props.filter}/>
        </PDFViewer>
      </ModalDetailComponent>
    )
}

export default PopupPDFLean